import { useContext } from 'react'
import { VideoContext } from './context'
import type { VideoContextType } from './types'

export const useVideoContext = (): VideoContextType => {
  const ctx = useContext(VideoContext)
  if (!ctx) throw new Error('useVideoContext must be used inside VideoProvider')
  return ctx
}

export default useVideoContext
